export default __webpack_public_path__ + "static/media/sort_down.f60a45c0.svg";